"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawdownStatSummary = void 0;
var _core = require("@material-ui/core");
var _accounting = _interopRequireDefault(require("accounting"));
var _currencySymbolMap = _interopRequireDefault(require("currency-symbol-map"));
var _react = _interopRequireDefault(require("react"));
var _Flag = require("../../Flag");
var _DrawdownStatSummary = require("./DrawdownStatSummary.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DrawdownStatSummary = function DrawdownStatSummary(props) {
  var _props$testId, _props$testId2, _props$testId3, _props$testId4;
  var classes = (0, _DrawdownStatSummary.useStyles)();
  var summaryData = props.data;
  var flagSize = 18;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": props.testId,
    className: classes.root,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    className: classes.group,
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": (_props$testId = props.testId) === null || _props$testId === void 0 ? void 0 : _props$testId.concat('-sell-amount'),
    className: classes.title
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.secondaryTitle
  }, summaryData.sellAmountText ? summaryData.sellAmountText : 'Sell Amount'), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.value
  }, /*#__PURE__*/_react["default"].createElement(_Flag.Flag, {
    size: flagSize,
    code: summaryData.tradeCurrencySell
  }), ' ', (0, _currencySymbolMap["default"])(summaryData.tradeCurrencySell) || summaryData.tradeCurrencySell, ' ', "".concat(_accounting["default"].format(summaryData.sellAmount, 2, summaryData.europeanLocale ? '.' : ',', summaryData.europeanLocale ? ',' : '.')))), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": (_props$testId2 = props.testId) === null || _props$testId2 === void 0 ? void 0 : _props$testId2.concat('-rate'),
    className: classes.title
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.secondaryTitle
  }, summaryData.rateText ? summaryData.rateText : 'Rate'), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.rateValue
  }, "".concat(_accounting["default"].format(summaryData.rate, 6, summaryData.europeanLocale ? '.' : ',', summaryData.europeanLocale ? ',' : '.')))), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": (_props$testId3 = props.testId) === null || _props$testId3 === void 0 ? void 0 : _props$testId3.concat('-trade-type'),
    className: classes.title
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.secondaryTitle
  }, summaryData.buyAmountText ? summaryData.buyAmountText : 'Buy Amount'), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.value
  }, /*#__PURE__*/_react["default"].createElement(_Flag.Flag, {
    size: flagSize,
    code: summaryData.tradeCurrencyBuy
  }), ' ', (0, _currencySymbolMap["default"])(summaryData.tradeCurrencyBuy) || summaryData.tradeCurrencyBuy, ' ', "".concat(_accounting["default"].format(summaryData.buyAmount, 2, summaryData.europeanLocale ? '.' : ',', summaryData.europeanLocale ? ',' : '.')))), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": (_props$testId4 = props.testId) === null || _props$testId4 === void 0 ? void 0 : _props$testId4.concat('-value-date'),
    className: classes.title
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.secondaryTitle
  }, summaryData.valueDateText ? summaryData.valueDateText : 'Value Date'), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.value
  }, summaryData.valueDate || '-'))))));
};
exports.DrawdownStatSummary = DrawdownStatSummary;